"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultLogger = console;
function toLogger(partialLogger) {
    if (partialLogger.error &&
        partialLogger.group &&
        partialLogger.groupCollapsed &&
        partialLogger.groupEnd &&
        partialLogger.warn) {
        return partialLogger;
    }
    var spaces = 2;
    var indent = 0;
    return {
        error: function (message) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            call.apply(void 0, ["error", message].concat(args));
        },
        group: function (title) {
            call("log", title);
            indent += spaces;
        },
        groupCollapsed: function (title) {
            call("log", title);
            indent += spaces;
        },
        groupEnd: function () {
            indent = Math.max(0, indent - spaces);
        },
        log: function (message) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            call.apply(void 0, ["log", message].concat(args));
        },
        warn: function (message) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            call.apply(void 0, ["warn", message].concat(args));
        }
    };
    function call(method, message) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        var _a;
        var padding = " ".repeat(indent);
        if (message) {
            message = padding + message;
        }
        else {
            message = padding;
        }
        (_a = (partialLogger[method] || partialLogger.log)).call.apply(_a, [partialLogger, message].concat(args));
    }
}
exports.toLogger = toLogger;
